export const InfoRequestEndpoint = (makeRequest) => {
    return {
        fetchLandingPageContent(params, options) {
            return makeRequest('GET', '/v1/hub_referral/info_request/fetch_landing_page_content', params, options);
        },
        fetchAuthPageContent(params, options) {
            return makeRequest('GET', '/v1/hub_referral/info_request/fetch_auth_page_content', params, options);
        },
        createAuth(params, options) {
            return makeRequest('POST', '/v1/hub_referral/info_request/create_auth', params, options);
        },
        fetchInsurancePageContent(params, options) {
            return makeRequest('GET', '/v1/hub_referral/info_request/fetch_insurance_page_content', params, options);
        },
        fetchCommsConfigPageContent(params, options) {
            return makeRequest('GET', '/v1/hub_referral/info_request/fetch_comms_config_page_content', params, options);
        },
        createCommsConfig(params, options) {
            return makeRequest('POST', '/v1/hub_referral/info_request/create_comms_config', params, options);
        },
        fetchCompletePageContent(params, options) {
            return makeRequest('GET', '/v1/hub_referral/info_request/fetch_complete_page_content', params, options);
        },
    };
};
//# sourceMappingURL=info_request_endpoint.js.map